import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import TechTrustStrip from "./components/TechTrustStrip";
import TrustHighlight from "./components/TrustHighlight";
import VisualSlider from "./components/VisualSlider";
import ClientTrustSlider from "./components/ClientTrustSlider";
import AwardsSection from "./components/AwardsSection";
import BusinessImpactSection from "./components/BusinessImpactSection";
import ServicesSection from "./components/ServicesSection";
import LaravelExpertiseSection from "./components/LaravelExpertiseSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import ProcessSection from "./components/ProcessSection";
import TechStackSection from "./components/TechStackSection";
import PortfolioSection from "./components/PortfolioSection";
import IndustriesSection from "./components/IndustriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import EngagementModelsSection from "./components/EngagementModelsSection";
import SecuritySection from "./components/SecuritySection";
import CTASection from "./components/CTASection";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        {/* Hero */}
        <HeroSection />

        {/* Core Technology Trust Strip */}
        <TechTrustStrip />

        {/* Small Trust Highlight near top */}
        <TrustHighlight />

        {/* Premium IT Visual Slider */}
        <VisualSlider />

        {/* Client / Business Highlight Slider */}
        <ClientTrustSlider />

        {/* Awards & Accolades */}
        <AwardsSection />

        {/* Business Impact / Client Highlights */}
        <BusinessImpactSection />

        {/* Services */}
        <ServicesSection />

        {/* Laravel Expertise */}
        <LaravelExpertiseSection />

        {/* Why Choose Us */}
        <WhyChooseUsSection />

        {/* Development Process */}
        <ProcessSection />

        {/* Technologies We Work With */}
        <TechStackSection />

        {/* Portfolio / Case Studies */}
        <PortfolioSection />

        {/* Industries */}
        <IndustriesSection />

        {/* Testimonials */}
        <TestimonialsSection />

        {/* FAQ */}
        <FAQSection />

        {/* Engagement Models */}
        <EngagementModelsSection />

        {/* Security */}
        <SecuritySection />

        {/* Final CTA */}
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}